var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlintIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.849 9.86793L16.2311 2.38033C16.7357 1.82773 16.9159 1.88156 17.088 2.51403L17.1539 7.86233C17.1355 8.69691 17.0749 9.05682 16.8244 9.39996L12.3423 14.0129C11.7563 14.7376 11.8367 15.0268 11.815 15.3499C11.7934 15.673 12.3853 16.6151 13.3969 16.687C13.3969 16.687 16.1401 16.6876 16.4288 16.687C16.7175 16.6864 16.9198 17.1515 16.4288 17.623L10.2331 23.8404C9.46638 24.5626 9.03263 24.5606 8.2558 24.3083C7.06351 23.64 7.04221 23.0231 7.00505 21.9472L7.00347 21.9016V15.0825C6.96218 12.9087 7.27295 11.7504 8.849 9.86793Z",
    fill: "#FF6100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2161 22.132L14.6104 29.6196C14.0905 30.1723 13.9048 30.1185 13.7276 29.4859L13.6597 24.1376C13.6785 23.3032 13.6469 23.6283 14.7383 22.2822L18.617 17.9872C19.2208 17.2624 19.1379 16.9732 19.1603 16.6501C19.1826 16.327 18.5728 15.3849 17.5304 15.313C17.5304 15.313 14.7042 15.3124 14.4067 15.313C14.1092 15.3136 13.9007 14.8484 14.4067 14.377L20.7901 8.15962C21.58 7.43736 22.0271 7.43937 22.8274 7.69165C24.0558 8.36001 24.0777 8.97698 24.1161 10.0528L24.1176 10.0984V16.9174C24.1602 19.0914 23.8401 20.2496 22.2161 22.132Z",
    fill: "#FF6100"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlintIcon);
export default __webpack_public_path__ + "static/media/flint-icon.55f5f5f6.svg";
export { ForwardRef as ReactComponent };